export default __webpack_public_path__ + "static/media/invest_navicon-light.c6c2ee09.svg";